import gql from 'graphql-tag';

export const fields = `
    accountId
    account {
        id
        username
        email
        user {
            id
            name
            surname
            langId
        }
    }
    companyId
    company {
        id
    }
    fleetIds
    createdAt
    updatedAt
`;

export const relationsFields = `
`;

// default methods
export const paginationQuery = gql`
    query DigitaiPaginateOperators (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        pagination: digitaiPaginateOperators (
            query: $query
            constraint: $constraint
        ) {
            total
            rows
            count
        }
    }
`;

export const getQuery = gql`
    query DigitaiGetOperators (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        objects: digitaiGetOperators (
            query: $query
            constraint: $constraint
        ) {
            id
            #FIELDS
        }
    }
`;

export const findByIdQuery = gql`
    query DigitaiFindOperatorById (
        $id: ID
        $constraint: QueryStatement
    ) {
        object: digitaiFindOperatorById (
            id: $id
            constraint: $constraint
        ) {
            id
            #FIELDS
        }
    }
`;

export const findQuery = gql`
    query DigitaiFindOperator (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        object: digitaiFindOperator (
            query: $query
            constraint: $constraint
        ) {
            id
            #FIELDS
        }
    }
`;

export const createMutation = gql`
    mutation DigitaiCreateOperator (
        $payload: DigitaiCreateOperatorInput!
    ) {
        digitaiCreateOperator (
            payload: $payload
        ) {
            ${fields}
        }
    }
`;

export const insertMutation = gql`
    mutation DigitaiCreateOperators (
        $payload: [DigitaiCreateOperatorInput]!
    ) {
        digitaiCreateOperators (
            payload: $payload
        )
    }
`;

export const updateByIdMutation = gql`
    mutation DigitaiUpdateOperatorById (
        $payload: DigitaiUpdateOperatorByIdInput!
        $constraint: QueryStatement
    ) {
        digitaiUpdateOperatorById (
            payload: $payload
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

export const updateMutation = gql`
    mutation DigitaiUpdateOperators (
        $payload: DigitaiUpdateOperatorsInput!
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        digitaiUpdateOperators (
            payload: $payload
            query: $query
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

export const deleteByIdMutation = gql`
    mutation DigitaiDeleteOperatorById (
        $id: ID!
        $constraint: QueryStatement
    ) {
        digitaiDeleteOperatorById (
            id: $id
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

export const deleteMutation = gql`
    mutation DigitaiDeleteOperators (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        digitaiDeleteOperators (
            query: $query
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;
